import { render, staticRenderFns } from "./ReturnsIndex.vue?vue&type=template&id=738c12bc&scoped=true"
import script from "./ReturnsIndex.vue?vue&type=script&lang=js"
export * from "./ReturnsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c12bc",
  null
  
)

export default component.exports